import { useState } from "react";
import { geturl } from "../../Utils/helper";

interface ImageProps {
  src: string;
  inlineClass?: string;
  onClick?: () => void;
  alt?: string; // optional alt prop
}

const LoadImage = ({ src, inlineClass, onClick, alt }: ImageProps) => {
  const [defaultImage, setDefaultImage] = useState(false);

  return (
    <img
      src={
        defaultImage || !src
          ? "/assets/images/skyAzul_logo.jpg"
          : geturl(src) || "/assets/images/skyAzul_logo.jpg"
      }
      className={inlineClass || "custom-class"}
      alt={alt || "product image"}
      onClick={onClick}
      onError={() => setDefaultImage(true)}
    />
  );
};

export default LoadImage;
